import React from 'react';
import './sec4.css'
import Categorycards from '../components/common/category-cards';
import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { supabase } from '../supabase';
import { useState } from 'react';
gsap.registerPlugin(ScrollTrigger);




const Sec4 = () => {

const [img, setimg]= useState([]);
const [headers, setheaders]= useState([]);
const doubled = [...(img || []), ...(img || [])];


useEffect(() => {
    if (!img || img.length === 0) return;
  const track = document.querySelector('.cards-track');
  const allItems = document.querySelectorAll('.card-item');
    if (!track || allItems.length === 0) return;
  let isPaused = false;
  let rafId;

  const applyBend = () => {
    allItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const screenCenter = window.innerWidth / 2;
      const distFromCenter = (centerX - screenCenter) / screenCenter;
       item.style.transform = `
        rotate(${distFromCenter * 12}deg)
        translateY(${Math.abs(distFromCenter) * 40}px)
      `;
    });

    if (!isPaused) {
      rafId = requestAnimationFrame(applyBend);
    }
  };

  const totalWidth = track.scrollWidth / 2;

  const tween = gsap.to(track, {
    x: `-=${totalWidth}`,
    ease: 'none',
    duration: 20,
    repeat: -1,
    modifiers: {
      x: gsap.utils.unitize((x) => parseFloat(x) % totalWidth),
    },
  });

  rafId = requestAnimationFrame(applyBend);

  track.addEventListener('mouseenter', () => {
    isPaused = true;
    cancelAnimationFrame(rafId);
    tween.pause();
  });

  track.addEventListener('mouseleave', () => {
    isPaused = false;
    tween.play();
    rafId = requestAnimationFrame(applyBend);
  });

  return () => {
    tween.kill();
    cancelAnimationFrame(rafId);
  };
}, [img]);


useEffect(() => {
  const getimg = async () => {
    const { data, error } = await supabase
      .from('category')
      .select('*')
      .eq('is_homepage', true)
      .limit(8);

    if (error) {
      console.log(error);
      return;
    }

    setimg(data || []);
  };

  getimg();
}, []);

useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
setheaders(res.data);
}
getheaders();
}, []);







    return ( 
        <section className='sec4'>
            <section className='container-cards-sec4'>
                    <h1 className='header-sec4'>{headers?.[2]?.header}</h1>
        <div className='cards-viewport'>
          <div className='cards-track'>



                    {doubled.map((card, index) => (
                      <div key={index} className='card-item'>
                        <Categorycards 
                          pic={card.image} 
                          alt={card.img_alt}
                          title={card.category_name} 
                        />
                      </div>
                    ))}

                </div>
                </div>
            </section>
        </section>
     );
}
 
export default Sec4;